import "./App.css";
import Web from "./Components/Routes/Web";
import { BrowserRouter as Router } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

function App() {
    return (
        <div className="App">
            <Router>
                <Web />
            </Router>
            <Analytics />
            <SpeedInsights />
        </div>
    );
}

export default App;
